import {Dimensions} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-x-helper';
import {getStatusBarHeight} from 'react-native-status-bar-height';

export const screenWidth = () => Dimensions.get('window').width;
export const screenHeight = () => Dimensions.get('window').height;

export const statusBarHeight = getStatusBarHeight();
export const bottomSpace = getBottomSpace();

export const indent = 20;
